import LabelInputField from './LabelInputField';

export default LabelInputField;
